<template>
    <div class="coming-soon">
        <div class="coming-soon-card">
            <div class="coming-soon-eyebrow">Próximamente</div>
            <h2 class="coming-soon-title">{{ label }}</h2>
            <p class="coming-soon-description">{{ description }}</p>
        </div>
    </div>
</template>

<script>
const DEFAULT_DESCRIPTION =
    "Esta sección está en construcción. Estará disponible próximamente.";

export default {
    name: "ComingSoon",
    props: {
        label: {
            type: String,
            required: true,
        },
        // Texto descriptivo opcional. Si no se pasa, usa el genérico de
        // "construcción". Permite a cada section dar contexto específico.
        description: {
            type: String,
            default: DEFAULT_DESCRIPTION,
        },
    },
};
</script>

<style lang="scss" scoped>
.coming-soon {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 64px 24px;
    min-height: 50vh;
}

.coming-soon-card {
    max-width: 480px;
    width: 100%;
    padding: 32px;
    background-color: #ffffff;
    border: 1px solid #eaecf0;
    border-radius: 12px;
    text-align: center;
    box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);
}

.coming-soon-eyebrow {
    text-transform: uppercase;
    letter-spacing: 0.06em;
    font-size: 12px;
    font-weight: 600;
    color: #0d5154;
    margin-bottom: 8px;
}

.coming-soon-title {
    font-size: 24px;
    font-weight: 700;
    color: #101828;
    margin: 0 0 12px;
}

.coming-soon-description {
    font-size: 14px;
    line-height: 20px;
    color: #475467;
    margin: 0;
}
</style>
